import React from 'react'
import ManageTrendingsComponent from '../../../../components/partner/Settings/manage-trendings/ManageTrendingsComponent'

function ManageTrendingsPage() {
  return <ManageTrendingsComponent />
}

export default ManageTrendingsPage